// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B37t","left":"styles_left__1q5hK"};